import { Button } from '@/components/ui/button'
import { Download, FolderInput, RotateCcw, Share2, Trash2, X } from 'lucide-react'

interface FinderBulkActionsProps {
    selectedCount: number
    onClear: () => void
    onMoveTo: () => void
    onShare: () => void
    onDownload: () => void
    onDelete: () => void
    isTrashSection?: boolean
    onRestore?: () => void
    onPermanentDelete?: () => void
}

export function FinderBulkActions({
    selectedCount,
    onClear,
    onMoveTo,
    onShare,
    onDownload,
    onDelete,
    isTrashSection = false,
    onRestore,
    onPermanentDelete,
}: FinderBulkActionsProps) {
    if (selectedCount === 0) return null

    return (
        <div className='absolute bottom-12 left-1/2 -translate-x-1/2 bg-white rounded-2xl shadow-2xl border border-gray-100 p-2 flex items-center gap-1 z-30 animate-in slide-in-from-bottom-4 duration-200'>
            <div className='flex items-center gap-2 px-3 text-sm'>
                <span className='font-medium text-gray-700'>{selectedCount}</span>
                <span className='text-gray-400'>selected</span>
            </div>
            <div className='w-px h-6 bg-gray-200 mx-1' />
            {isTrashSection ? (
                <>
                    <Button
                        variant='ghost'
                        size='sm'
                        onClick={onRestore}
                        className='gap-1.5 text-green-600 hover:text-green-700 hover:bg-green-50'
                    >
                        <RotateCcw className='w-4 h-4' />
                        <span className='text-xs'>Restore</span>
                    </Button>
                    <Button
                        variant='ghost'
                        size='sm'
                        onClick={onPermanentDelete}
                        className='gap-1.5 text-red-500 hover:text-red-600 hover:bg-red-50'
                    >
                        <Trash2 className='w-4 h-4' />
                        <span className='text-xs'>Delete</span>
                    </Button>
                </>
            ) : (
                <>
                    <Button variant='ghost' size='sm' onClick={onMoveTo} className='gap-1.5 text-gray-600'>
                        <FolderInput className='w-4 h-4' />
                        <span className='text-xs'>Move</span>
                    </Button>
                    <Button variant='ghost' size='sm' onClick={onShare} className='gap-1.5 text-gray-600'>
                        <Share2 className='w-4 h-4' />
                        <span className='text-xs'>Share</span>
                    </Button>
                    <Button variant='ghost' size='sm' onClick={onDownload} className='gap-1.5 text-gray-600'>
                        <Download className='w-4 h-4' />
                        <span className='text-xs'>Download</span>
                    </Button>
                    <Button
                        variant='ghost'
                        size='sm'
                        onClick={onDelete}
                        className='gap-1.5 text-red-500 hover:text-red-600 hover:bg-red-50'
                    >
                        <Trash2 className='w-4 h-4' />
                        <span className='text-xs'>Trash</span>
                    </Button>
                </>
            )}
            <div className='w-px h-6 bg-gray-200 mx-1' />
            <Button variant='ghost' size='sm' onClick={onClear} className='p-1'>
                <X className='w-4 h-4 text-gray-400' />
            </Button>
        </div>
    )
}
